export default __webpack_public_path__ + "static/media/agrobion.50241b52.png";